import useUserPermissions from "../../../../../../common/utils/user/permissions/use-user-permissions";
import railyOfficerListingUserPermissionDefinition from "./raily-officer-listing-user-permission";

const useRailyOfficerListingUserPermissions = () => {
  return useUserPermissions(railyOfficerListingUserPermissionDefinition);
};

export default useRailyOfficerListingUserPermissions;
